import type { ResetParam } from './types';

export const RESET_PARAMS: ResetParam[] = [
	'searchText',
	'orderField',
	'orderDirection',
	'roleType',
	'roleIds',
];
